import dayjs from 'dayjs';

import {
  snapshotFailure,
  snapshotRequest,
  snapshotSuccess,
} from 'store/reducers/reports';

import { fetchData } from './fetchData';

export const loadReportSnapshot =
  ({ range }) =>
  (dispatch, getState) => {
    const { provider } = getState();
    const luid = provider.locations?.[0]?.uuid;
    const { uuid: groomerUuid } = getState().ui.selectedGroomer;

    const [start, end] = range;
    const startDate = dayjs(start).format('YYYY-MM-DD');
    const endDate = dayjs(end).format('YYYY-MM-DD');
    const groomerQuery =
      groomerUuid && groomerUuid !== 'all' ? `&user_uuid=${groomerUuid}` : '';

    return fetchData({
      endpoint: `location/${luid}/reports/snapshot?date_start=${startDate}&date_end=${endDate}${groomerQuery}`,
      actions: [snapshotRequest, snapshotSuccess, snapshotFailure],
    })(dispatch, getState);
  };
